import React from "react";
import Navbar from "../components/Navbar";
import CarouselBanner from "../components/CarouselBanner";
import AboutPreview from "../components/AboutPreview";
import WhyChooseUs from "../components/WhyChooseUs";
import ExpertiseCards from "../components/ExpertiseCards";
import PartnerCards from "../components/PartnerCards";
import BookCall from "../components/BookCall"; 
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollToTopButton";

export default function HomePage() {
  return (
    <>
      <Navbar />
      <div style={{ marginTop: "50px" }}>
        <CarouselBanner />
        <AboutPreview />
        <WhyChooseUs />
        <BookCall /> 
        <ExpertiseCards />
        <PartnerCards />
        <Footer />
        <ScrollToTopButton />
      </div>
    </>
  );
}
